<script lang="ts">
  import { useWallet } from '@do/svelte-web3-manager';

  import { Avatar } from '@shared/ui/avatar';

  import { formatWalletId } from '@entities/wallet/libs';

  const wallet = useWallet();
</script>

{#if $wallet}
  <div class="bg-default-100 dark:bg-dark-100 flex w-max items-center gap-2 rounded-full py-1 pl-2 pr-5">
    <div class="p-1">
      <Avatar wallet="{$wallet.address}" width="{20}" />
    </div>

    <p class="text-base font-medium lowercase">
      {formatWalletId($wallet.address)}
    </p>
  </div>
{/if}
